import React from 'react';
import { Link } from 'react-router-dom';
import TrustBlocks from './TrustBlocks';
import FaqAccordion from './FaqAccordion';
import PageSEO from './PageSEO';

const LeaseSigningLanding = () => {
  return (
    <main className="App-main intent-landing">
      <PageSEO title="Ontario Lease Generation & E-Signatures | Rentual" description="Generate Ontario standard leases pre-filled from screening data. Tenants and landlords sign digitally. Compliant with the RTA." path="/lease-signing" />
      <section className="intent-hero">
        <p className="eyebrow-tag">Lease Signing</p>
        <h1>Get Ontario leases signed and stored fast.</h1>
        <p className="hero-subhead">
          Use the Ontario Standard Lease, collect signatures, and move into rent payments right away.
        </p>
        <div className="hero-ctas">
          <Link className="primary-button" to="/register">Start free trial</Link>
          <Link className="ghost-button" to="/pricing">View pricing</Link>
        </div>
      </section>

      <section className="steps-section">
        <p className="eyebrow-tag">Lease checklist</p>
        <h2>Stay compliant from day one.</h2>
        <div className="steps-grid">
          <article className="step-card">
            <div className="step-number">1</div>
            <h3>Standard Lease</h3>
            <p>Use the latest Ontario Standard Lease as your base document.</p>
          </article>
          <article className="step-card">
            <div className="step-number">2</div>
            <h3>Appendices</h3>
            <p>Add rules, utilities, and maintenance responsibilities as needed.</p>
          </article>
          <article className="step-card">
            <div className="step-number">3</div>
            <h3>Store &amp; share</h3>
            <p>Keep signed documents secure and easy to retrieve.</p>
          </article>
        </div>
      </section>

      <section className="capabilities-section">
        <p className="eyebrow-tag">Feature highlights</p>
        <h2>Lease management without the paperwork chaos.</h2>
        <div className="capabilities-grid">
          <article className="capability-card">
            <div className="capability-icon">01</div>
            <h3>Document vault</h3>
            <p>Centralize leases, renewals, and attachments for every tenant.</p>
          </article>
          <article className="capability-card">
            <div className="capability-icon">02</div>
            <h3>Audit-ready records</h3>
            <p>Maintain a clear trail for compliance and LTB needs.</p>
          </article>
          <article className="capability-card">
            <div className="capability-icon">03</div>
            <h3>Payment-ready handoff</h3>
            <p>Turn on rent payments as soon as the lease is signed.</p>
          </article>
        </div>
      </section>

      <TrustBlocks />

      <section className="pricing-preview">
        <p className="eyebrow-tag">Pricing</p>
        <h2>Simple plans for Ontario landlords.</h2>
        <div className="pricing-preview-grid">
          <div className="pricing-preview-card">
            <h3>Starter</h3>
            <p>Up to 5 units</p>
            <strong>$19/mo</strong>
          </div>
          <div className="pricing-preview-card">
            <h3>Growth</h3>
            <p>Up to 25 units</p>
            <strong>$59/mo</strong>
          </div>
          <div className="pricing-preview-card">
            <h3>Pro</h3>
            <p>Up to 100 units · Payments included</p>
            <strong>$149/mo</strong>
          </div>
        </div>
        <div className="hero-ctas">
          <Link className="ghost-button" to="/pricing">Compare plans</Link>
        </div>
      </section>

      <section className="faq-section">
        <p className="eyebrow-tag">FAQ</p>
        <h2>Questions about leases?</h2>
        <FaqAccordion items={[
          { question: 'Do I have to use the Ontario Standard Lease?', answer: 'Yes. It\'s required for most residential tenancies in Ontario.' },
          { question: 'Can I store lease appendices?', answer: 'Yes. Upload addendums and attachments alongside the lease.' },
          { question: 'Is lease storage secure?', answer: 'Yes. Files are encrypted in transit and protected with role-based access.' }
        ]} />
      </section>

      <section className="cta-panel">
        <h3>Ready to sign leases and get paid?</h3>
        <p>Start your free trial and enable rent payments in minutes.</p>
        <div className="hero-ctas">
          <Link className="primary-button" to="/register">Start free trial</Link>
          <Link className="ghost-button" to="/contact">Talk to us</Link>
        </div>
      </section>
    </main>
  );
};

export default LeaseSigningLanding;
